import React from "react";
import css from "./CoachMark.module.scss";
import { coachmark_pin, pointer } from "../../Images/Icons";
import { NavLink } from "react-router-dom";
const CoachMarkStep5 = (props) => {
    return (
        <div style={{ position: "relative" }}>
            <div className={css.backdrop}>
                <div className={css.higlight5}>
                    <div className={css.point}>
                        <img src={coachmark_pin}/>
                    </div>
                </div>
                <div className={css.content}>                
                    <i class="fi fi-rr-cross-small"></i>
                    <div className={css.title}>⚡ Track PV Energy Production.</div>
                    <div className={css.desc}>Keep an eye on your solar power performance! This section displays crucial data on energy production and consumption from your PV system. Monitor how much energy you're generating and using in real-time. </div>
                    <div className={css.step}>5/10</div>
                    <NavLink to="/home" onClick={props.prev}>
                        <button className={css.prev}>Previous</button>
                    </NavLink>
                    <NavLink to="/home" onClick={props.next}>
                        <button className={css.next}>Next</button>
                    </NavLink>
                    
                </div>
            </div>
        </div>
    );
};

export default CoachMarkStep5;
